import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://diccionario-apple.impultienda.ar/checkout';
type CTAButtonProps = {
  label?: string;
  note?: string;
  className?: string;
};
export function CTAButton({
  label = 'IR AL PAGO SEGURO',
  note,
  className = ''
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center gap-3 ${className}`} data-id="element-109" data-mp="2fyjucvxjd09c">
      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="group inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-full bg-accent px-8 py-5 text-center text-sm font-bold uppercase tracking-wide text-white shadow-[0_10px_40px_-12px_rgba(10,132,255,0.9)] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-accent-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft focus-visible:ring-offset-2 focus-visible:ring-offset-ink-950 sm:text-base" data-id="element-110" data-mp="2tz2z9u6pfq7a">
        {label}
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-111" data-mp="38pk5rry756b1" />
      </a>
      {note ? <p className="text-xs text-white/45 sm:text-sm" data-id="element-112" data-mp="1da8b1h4dw7du">{note}</p> : null}
    </div>;
}